module.exports = __webpack_public_path__ + "static/media/microsoft.98a41061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assets-for-demo/ourClients/microsoft.jpg
// module id = 1234
// module chunks = 0